export const ApiConstant = {
  API_BASE_URL: "https://service-lensman.mitetechnology.in",
  LOGIN: "/api/v1/lm-users/login",
  LOGOUT: "/api/v1/lm-users/logout",
  ENCRYPTION: "/api/v1/lm-users/get_info",
  // Academic Year
  GET_ACADEMIC_YEAR: "/api/v1/school/academic_years_list",
  GET_RECENT_ACADEMIC_YEAR: "/api/v1/school/academic_years/recent",
  GET_SINGLE_ACADEMIC_YEAR: "/api/v1/school/academic/details",
  UPDATE_ACADEMIC_YEAR_STATUS: "/api/v1/school/update_accademic_years",
  UPDATE_BULK_ACADEMIC_YEAR_STATUS: "/api/v1/school/academic_group_status",
  ADD_ACADEMIC_YEAR: "/api/v1/school/save_accademic_years",
  EDIT_ACADEMIC_YEAR: "/api/v1/school/update_accademic_years/",
  ACADEMIC_YEAR_EXCEL_DOWNLOAD: "/api/v1/excel/academic/year",

  //school
  SCHOOL_LIST: "/api/v1/school/school_list",
  GET_SINGLE_SCHOOL: "/api/v1/school/schools/school_id",
  GET_SCHOOL_GROUP_LIST: "/api/v1/school/school_group_list",
  UPDATE_SCHOOL_STATUS: "/api/v1/school/update_school_status",
  ADD_SCHOOL_GROUP: "/api/v1/school/save_school_group",
  ADD_SCHOOL: "/api/v1/school/save_school",
  EDIT_SCHOOL: "/api/v1/school/update_school",
  SCHOOL_BULK_STATUS_UPDATE: "/api/v1/school/school_group_status",
  SCHOOL_EXCEL_DOWNLAOD: "/api/v1/excel/school",
  SCHOOL_PACKAGE_LIST: "/api/v1/school/school_packages",
  UPDATE_SCHOOL_PACKAGE_LIST: "/api/v1/school/school_package_update",
  STUDENT_INVITE_DATA: "/api/v1/school/school_data/student_invite/data",
  UPDATE_BASE_PRICE: "/api/v1/poses/update_price",
  ADD_PROMO_CODE: "/api/v1/promo_code/create",
  EDIT_PROMO_CODE: "/api/v1/promo_code/update",
  GET_PROMO_CODE_LIST: "/api/v1/promo_code/get_list",
  DELETE_PROMO_LINK_STUDENT: "/api/v1/promo_code/student/link_delete",

  //user management
  USER_LIST: "/api/v1/user_manage/users",
  USER_UPDATE: "/api/v1/user_manage/user/update",
  USER_STATUS_UPDATE: "/api/v1/user_manage/user/update/status",
  USER_CREATION: "/api/v1/user_manage/register",
  USER_SINGLE: "/api/v1/user_manage/user/details",
  USER_EXCEL_DOWNLOAD: "/api/v1/excel/user_manage",

  //pose management
  POSE_LIST: "/api/v1/poses/list",
  POSE_CREATE: "/api/v1/poses/create",
  POSE_DETAILS: "/api/v1/poses/details",
  POSE_UPDATE: "/api/v1/poses/update",
  POSE_UPDATE_STATUS: "/api/v1/poses/update/status",
  POSE_LATEST_NAME: "/api/v1/poses/new/name/creation",
  POSE_EXCEL_DOWNLOAD: "/api/v1/excel/poses",

  //group photo
  GROUP_PHOTO_LIST: "/api/v1/poses/group/photo/list",
  GROUP_PHOTO_PACKAGES_LIST: "/api/v1/poses/package/details",
  GROUP_PHOTO_CREATE: "/api/v1/poses/group/photo/create",
  GROUP_PHOTO_DETAILS: "/api/v1/poses/group/photo/details",
  GROUP_PHOTO_UPDATE: "/api/v1/poses/group/photo/update",
  GROUP_PHOTO_TYPE_CREATE: "/api/v1/poses/group/type/create",
  GROUP_PHOTO_TYPE_LIST: "/api/v1/poses/group/type/list",
  GROUP_PHOTO_TYPE_UPDATE_STATUS: "/api/v1/poses/group/type/update/status",
  GROUP_PHOTO_UPDATE_STATUS: "/api/v1/poses/group/photo/update/status",
  GROUP_PHOTO__EXCEL_DOWNLOAD: "/api/v1/excel/group/photos",
  GROUP_PHOTO_DELETE: "/api/v1/poses/group/photo/delete",

  // Class and division

  GET_CLASS_AND_DIVISION: "/api/v1/school/classes_divisions",
  EDIT_CLASS_AND_DIVISION: "/api/v1/school/classes/",
  STATUS_UPDATE_CLASS_AND_DIVISION: "/api/v1/school/update_class_status",
  ADD_CLASS_AND_DIVISION: "/api/v1/school/save_class",
  DIVISION_STATUS_UPDATE: "/api/v1/school/update_division_status",
  GET_SINGLE_CLASS: "/api/v1/school/classes/",
  ADD_DIVISION: "/api/v1/school/classes/divsion_add",
  REMOVE_DIVISION: "/api/v1/school/classes/remove_div",
  GROUP_STATUS_UPDATE_CLASS: "/api/v1/school/class_group_status",
  CLASS_EXCEL_DOWNLOAD: "/api/v1/excel/class/div",
  UPDATE_DIVISION: "/api/v1/school/classes/remove_div",

  // Package management
  PACKAGE_LIST: "/api/v1/packages/list",
  PACKAGE_CREATE: "/api/v1/packages/create",
  PACKAGE_DETAILS: "/api/v1/packages/details",
  PACKAGE_STATUS_UPDATE: "/api/v1/packages/update/status",
  PACKAGE_UPDATE: "/api/v1/packages/update",
  PACKAGE_EXCEL_DOWNLOAD: "/api/v1/excel/packages",

  // Country management
  COUNTRY_DETAILS: "/api/v1/country/details_id",
  COUNTRY_LIST: "/api/v1/country/list_countries",
  COUNTRY_CREATE: "/api/v1/country/register",
  COUNTRY_UPDATE: "/api/v1/country/update",
  COUNTRY_EXCEL_DOWNLOAD: "/api/v1/excel/country",
  COUNTRY_BULK_STATUS_UPDATE: "/api/v1/country/group_update",

  //Location managment
  LOCATION_DETAILS: "/api/v1/delivery/details",
  LOCATION_LIST: "/api/v1/delivery/list",
  LOCATION_CREATE: "/api/v1/delivery/create",
  LOCATION_UPDATE: "/api/v1/delivery/update",
  LOCATION_EXCEL_DOWNLOAD: "/api/v1/excel/delivery",
  LOCATION_BULK_STATUS_UPDATE: "/api/v1/delivery/update/status",

  //parent management
  PARENT_LIST: "/api/v1/parents/parents/list",
  PARENT_DETAILS: "/api/v1/parents/parents/details",
  PARENT_UPDATE: "/api/v1/parents/parents/update",
  PARENT_UPDATE_STATUS: "/api/v1/parents/parents/update/status",
  PARENT_STUDENT_LIST: "/api/v1/parents/student/list",
  PARENT_STUDENT_UPDATE_STATUS: "/api/v1/parents/students/update/status",
  PARENT_STUDENT_DELETE: "/api/v1/parents/students/delete",
  PARENT_EXCEL_DOWNLOAD: "/api/v1/excel/parents",

  // student
  GET_STUDENT_LIST: "/api/v1/students/students_list",
  STUDENT_STATUS_UPDATE: "/api/v1/students/update_student_status",
  ADD_STUDENT: "/api/v1/students/student",
  GET_SINGLE_STUDENT: "/api/v1/students/students/id",
  EDIT_STUDENT: "/api/v1/students/update_student",
  STUDENT_BULK_STATUS_UPDATE: "/api/v1/students/students/bulk_update_status",
  STUDENT_DELETE: "/api/v1/parents/students/delete",
  STUDENT_BULK_DELETE: "/api/v1/students/bulk_delete",
  DOWNLOAD_EXCEL_FORMAT: "/api/v1/students/bulk-upload/template",
  STUDENT_EXCEL_DOWNLAOD: "/api/v1/excel/students",
  STUDENT_BULK_TEMP: "/api/v1/students/students/bulk-import/temp",
  STUDENT_BULK_CREATE: "/api/v1/students/students/bulk-import/finalize/",
  STUDENT_BULK_TEMP_DELETE: "/api/v1/students/students/bulk-import/cancel/",
  GET_STUDENTS_BY_SCHOOL: "/api/v1/students/students_data",
  GET_SINGLE_PROMO: "/api/v1/promo_code/promo-code/id",

  //orders
  ORDER_LIST: "/api/v1/orders/orders/get",
  ORDER_UPDATE_STATUS: "/api/v1/orders/orders/id",
  REFUND_STATUS_UPDATE: "/api/v1/orders/orders/refund_status",
  ORDER_DETAILS: "/api/v1/orders/order_details/id",
  ORDER_NOTES_ADD: "/api/v1/orders/admin/notes",
  ORDER_NOTES_GET: "/api/v1/orders/admin/notes/id",
  ORDER_UPDATE_BULK_STATUS: "/api/v1/orders/order/group/update",
  ORDER_CHECK_PAYMENT_STATUS: "/api/v2/public/order/payment/status",
  ORDER_EXCEL_DOWNLOAD: "/api/v2/excel/orders",
  ORDER_INVOICE_BULK_DOWNLOAD: "/api/v1/orders/bulk-invoice-download",
  // ORDER_STUDENT_LIST: "/api/v1/parents/student/list",
  // ORDER_STUDENT_DELETE: "/api/v1/parents/students/delete",

  //photographer
  ACCESS_STUDENT_PROFILE: "/api/v1/photographer/students/passcode",

  //shared
  GENERATE_PRESIGNED_URL: "/api/v1/shared_link/generate_presigned_url",
  UPLOAD_TELEMETRY: "/api/v1/shared_link/upload_telemetry",
  GENERIC_R2_CONTENT_LIST_URL: "/api/v1/shared_link/generic_r2_content_list",
  GENERIC_R2_CONTENT_EDIT_URL: "/api/v1/shared_link/generic_r2_content_edit",
  GENERIC_R2_CONTENT_DELETE_URL:
    "/api/v1/shared_link/generic_r2_content_delete",

  // Dashboard
  DASHBOARD_COUNT: "/api/v1/dashboard/total-count-details",
  DASHBOARD_SCHOOL_DETAILS: "/api/v1/dashboard/school-details",
  DASHBOARD_ORDER_DETAILS: "/api/v1/dashboard/order-details",
  DASHBOARD_COMPLETED_OERDER_DETAILS:
    "/api/v1/dashboard/completed-order-details",
  DASHBOARD_PENDING_ORDER_DETAILS: "/api/v1/dashboard/pending-order-details",
  DASHBOARD_CANCELLED_ORDER_DETAILS: "/api/v1/dashboard/cancelled-order-details",
  DASHBOARD_STUDENT_DETAILS: "/api/v1/dashboard/student-details",
  DASHBOARD_REVENUE_DETAILS: "/api/v1/dashboard/revenue-summary",

  // Maintenance mode (admin control endpoints are exempt from the 503 response)
  MAINTENANCE_STATE: "/api/v1/admin/maintenance",
  MAINTENANCE_DEFAULT_MESSAGE: "/api/v1/admin/maintenance/default-message",
};
